import { myFetch, HttpMethod } from "./baseService";

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export interface ObtenerDesperfectosRequest {
  codigo?: string;
  "unidad residencial codigo": string;
  "usuario que reporto daño"?: string;
  "estatus codigo"?: string;
  "fecha inicial"?: string;
  "fecha final"?: string;
}

export interface DesperfectoRecord {
  des_codigo: number | string;
  des_usuario: string;
  des_tipo_usuario: string;
  des_tipo_usuario_nombre: string;
  des_estatus: string;
  des_estatus_nombre: string;
  des_descripcion: string;
  des_fecha_creacion: string;
  des_respuesta: string;
  des_fecha_cierre: string;
  des_ruta_foto?: string;
}

export interface EstatusDesperfecto {
  ede_codigo?: string;
  ede_nombre?: string;
  des_estatus?: string;
  des_estatus_nombre?: string;
  codigo?: string;
  nombre?: string;
}

export interface ResponderDesperfectoRequest {
  codigo: string;
  respuesta: string;
}

export interface CerrarDesperfectoRequest {
  codigo: string;
}

export const obtenerDesperfectos = async (
  payload: ObtenerDesperfectosRequest
) => {
  const envelope = await myFetch<ApiEnvelope<DesperfectoRecord[]>>(
    "desperfecto/ObtenerTodos",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export const obtenerEstatusDesperfecto = async () => {
  const envelope = await myFetch<ApiEnvelope<EstatusDesperfecto[]>>(
    "estatus_desperfecto/ObtenerTodos",
    HttpMethod.POST,
    {}
  );

  return envelope;
};

export const responderDesperfecto = async (
  payload: ResponderDesperfectoRequest
) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "desperfecto/Responder",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export const cerrarDesperfecto = async (
  payload: CerrarDesperfectoRequest
) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "desperfecto/Cerrar",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

